import React from "react";
import "./Footer.css";

// Same three columns and copy as the original Footer.jsx (mailing list,
// follow us, connect), restyled with the brand-kit tokens instead of
// inline styles, and with the old per-platform brand colors (Twitter blue,
// Instagram pink, YouTube red) replaced by a single consistent accent
// color — a deliberate call to keep the footer feeling like one considered
// system rather than a row of borrowed platform colors. Icons are small
// inline SVGs rather than Font Awesome, since the old `<link>` tag inside
// the JSX output isn't a reliable way to load a stylesheet, and pulling in
// an entire icon library over CDN for three glyphs isn't worth it when
// FooterPlayer already established a lightweight custom-icon pattern.

function PatreonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <circle cx="15" cy="9" r="6" />
      <rect x="3" y="3" width="3" height="18" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.3" cy="6.7" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function YouTubeIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <rect x="2.5" y="5.5" width="19" height="13" rx="4" />
      <path d="M10.5 9.5v5l5-2.5-5-2.5z" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="mihu-footer" id="dept-footer">
      <div className="mihu-footer-inner">
        <a name="subscribe" />


        <div className="mihu-footer-col">
          <h3 className="mihu-footer-heading">Stay in the loop</h3>
          <p className="mihu-footer-note">New releases, events, and community news</p>
          <form method="post" action="/listserv" className="mihu-footer-form">
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Name"
              className="mihu-footer-input"
              required
            />
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              className="mihu-footer-input"
              required
            />
            <button type="submit" className="mihu-footer-submit">
              Subscribe
            </button>
          </form>
        </div>

        <div className="mihu-footer-col">
          <h3 className="mihu-footer-heading">Follow Us</h3>
          <ul className="mihu-footer-list">
            <li>
              <a href="https://www.patreon.com/c/musicishealing" target="_blank" rel="noreferrer">
                <PatreonIcon /> Patreon
              </a>
            </li>
            <li>
              <a href="http://instagram.com/musicishealingus" target="_blank" rel="noreferrer">
                <InstagramIcon /> Instagram
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCzFr7u6-hotJ32n1F9YG8zQ" target="_blank" rel="noreferrer">
                <YouTubeIcon /> YouTube
              </a>
            </li>
          </ul>
        </div>

        <div className="mihu-footer-col">
          <h3 className="mihu-footer-heading">Connect</h3>
          <ul className="mihu-footer-list">
            <li><a href="/submit">Submit</a></li>
            <li><a href="/advertise">Advertise</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/signin">Login</a></li>
          </ul>
        </div>
      </div>

      <hr className="mihu-footer-divider" />
      <p className="mihu-footer-copyright">
        © {new Date().getFullYear()} Music Is Healing
      </p>
    </footer>
  );
}
